import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Meta from "./meta";
import Spinner from "./components/landingpage/load";
import ChatWidget from './components/landingpage/ChatWidget';
import { loadMetaPixel, trackPageView } from "./pages/metaPixel";
import LoaderProvider from "./main/SimpleLoaderProvider";
import Navmain from './main/header';
import ScrollToTop from "./ScrollToTop"
import GTranslate from './GTranslate'; 





// import Vendor from "./main/vendor";

// import Sub from "./main/subcat";

// import Vendor_Detail from "./main/vendor_detail";

// import Blogdetail from "./components/landingpage/blogdetail"
// import Trade from "./components/landingpage/trade"
// import User from "./pages/leads/seller/profile/user";
// import Certificate from "./pages/leads/seller/profile/certificate";
// import Certificate_view from "./pages/leads/seller/profile/certificate_view";
// import Productinterest from "./pages/leads/seller/profile/productinterest";
// import Productinterestadd from "./pages/leads/seller/profile/productofinterestadd";
// import Myproducts from "./pages/leads/seller/profile/myproducts";
// Warehouse
// import Addwarehouse1 from "./pages/leads/seller/warehouse/Addwarehouse1";
// import Warehousebooking from "./pages/leads/seller/warehouse/Warehousebooking";
// import Warehouselist from "./pages/leads/seller/warehouse/Warehouselist";
// import Wareinvoices from "./pages/leads/seller/warehouse/wareinvoices";
// import Bulkproduct from "./pages/leads/seller/Products/Bulkproduct";

// Mattersheet
// import Matteradditionaldetails from "./pages/leads/seller/Mattersheet/Matteradditionaldetails";
// import Mattersheetdetails from "./pages/leads/seller/Mattersheet/Mattersheetdetails";
// import Mattersheetlist from "./pages/leads/seller/Mattersheet/Mattersheetlist";
// import Mattersheetdirector from "./pages/leads/seller/Mattersheet/Mattersheetdirector";
// import Upload from "./pages/leads/seller/Mattersheet/uploadproduct";
// import Table from "./pages/leads/seller/Mattersheet/table";

// Logistics
// import Request from "./pages/leads/seller/logistics/Request";
// import Bookingrequest_byRider from "./pages/leads/seller/logistics/Bookingrequest_byRider";
// import Bookingrequest_byUser from "./pages/leads/seller/logistics/Bookingrequest_byUser";
// import Bookingrequest_byUser_rebid from "./pages/leads/seller/logistics/Pendingdriver";
// import Bookingreceipt from "./pages/leads/seller/logistics/Bookingreceipt";
// import Myrides from "./pages/leads/seller/logistics/myrides";
// import Driverreg from "./pages/leads/seller/logistics/Driverreg";
// Ad-ons
// import Advertisewithus from "./pages/leads/seller/ad/advertisewithus";
// import Orderlist from "./pages/leads/seller/ad/orderlist";
// import Webmarketing from "./pages/leads/seller/ad/webmarketing";
// import Purchaseorder from "./pages/leads/buyer/buyerkhata/purchaseorder";
// import AdPurchaseorder from "./pages/leads/buyer/buyerkhata/adpurchase";
// Inventory
// './pages/leads/seller/inventory/sproductdef';
// import Productdef from "./pages/leads/seller/inventory/productdef";
// import Productpricing from "./pages/leads/seller/inventory/productpricing";
// import Productslist from "./pages/leads/seller/inventory/productslist";
// import Report from "./pages/leads/seller/inventory/reports";
// import Salesreturn from "./pages/leads/seller/inventory/salesreturn";
// import Stocklevels from "./pages/leads/seller/inventory/stocklevels";
// import ProductEditInventory from "./pages/leads/seller/inventory/productEdit";
// import Inventory from "./pages/leads/seller/inventory/inventory";
// import Purchasereportdetail from "./pages/leads/seller/inventory/purchasereportdetail";
// import Salereportdetail from "./pages/leads/seller/inventory/salereportdetail";

// import Web from "./components/landingpage/website";
// import Warehouse from "./components/landingpage/warehouse";
// import Book from "./components/landingpage/warehouse_booking";
// import Single from "./components/landingpage/singlewarehouse";

// import Final from "./components/landingpage/product_page";

// Logistics
// import Requestedbooking from "./pages/leads/buyer/warehouse/Bookingrequest";

// Warehouse
// import Bookinginvoices from "./pages/leads/buyer/warehouse/Warehousebooking";
// import Receiptl from "./pages/leads/buyer/warehouse/Warehouselist";

// Wallet
// import BWallet from "./pages/leads/buyer/wallet/bwallet";
// import BWallethistory from "./pages/leads/buyer/wallet/bwallethistory";
// import BBenificiary from "./pages/leads/buyer/wallet/bbenificiary";
// import BTopup from "./pages/leads/buyer/wallet/btopup";
// import BWithdraw from "./pages/leads/buyer/wallet/bwithdraw";

// Office Management
// import Employee from "./pages/leads/seller/office/employee";
// import Employee_form from "./pages/leads/seller/office/employee_form";
// import Emp_update from "./pages/leads/seller/office/update";
// import Payroll from "./pages/leads/seller/office/payroll";
// import Payroll_form from "./pages/leads/seller/office/payroll_form";
// import Officedashboard from "./pages/leads/seller/office/officedashboard";
// import Bill from "./pages/leads/seller/office/expense";
// import Adbill from "./pages/leads/seller/office/adexpense";
// import Homepage from "./components/landingpage/Homepage";
// import Subcat from "./components/landingpage/Subcat";
// import Main from "./components/landingpage/Main";
// import Product from './components/landingpage/Product';

// import Adcompany from "./pages/leads/seller/khata/addcompany";
// import Nav from "./components/landingpage/navbar";


// Website Routes
const Home = lazy(() => import(/* webpackPrefetch: true */ "./main/home"));
const Mains = lazy(() => import(/* webpackPrefetch: true */ "./main/cat"));
const Sub2 = lazy(() => import(/* webpackPrefetch: true */ "./main/subcat2"));
const Product_Detail = lazy(() => import(/* webpackPrefetch: true */ "./main/product_detail"));
const Supplier = lazy(() => import(/* webpackPrefetch: true */ "./components/landingpage/supplier"));
const Companypage = lazy(() => import(/* webpackPrefetch: true */ "./components/landingpage/companypage"));
const Search = lazy(() => import(/* webpackPrefetch: true */ "./components/landingpage/search"));
const Login = lazy(() => import(/* webpackPrefetch: true */ "./pages/login"));
const Signup = lazy(() => import(/* webpackPrefetch: true */ "./pages/Signup"));
const Forgotten = lazy(() => import(/* webpackPrefetch: true */ "./pages/forget"));
const Otp = lazy(() => import(/* webpackPrefetch: true */ "./pages/opt"));
const PrivacyPolicy = lazy(() => import(/* webpackPrefetch: true */ "./pages/PrivacyPolicy"));
const DeleteAccount = lazy(() => import(/* webpackPrefetch: true */ "./pages/DeleteAccount"));
const AboutUs = lazy(() => import(/* webpackPrefetch: true */ "./pages/AboutUs"));
const ContactUs = lazy(() => import(/* webpackPrefetch: true */ "./pages/ContactUs"));
const GetQuotePage = lazy(() => import(/* webpackPrefetch: true */ "./pages/GetQuotePage"));
const MasterLogin = lazy(() => import(/* webpackPrefetch: true */ "./main/MasterLogin"));
// Admin Panel Routes
const Requestno = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/Buyrequest/Requestno"));
const Sendrequest = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Buyleads/sendrequest"));
const Sendquote = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Buyleads/Sendquote"));
const Mainpage = lazy(() => import(/* webpackPrefetch: true */ "./pages/mainpage"));
const FacebookIntegrationPage = lazy(() => import(/* webpackPrefetch: true */ "./pages/FacebookIntegrationPage"));
const FacebookListing = lazy(() => import(/* webpackPrefetch: true */ "./pages/FacebookListing"));
const FacebookPosting = lazy(() => import(/* webpackPrefetch: true */ "./pages/FacebookPosting"));
const FacebookPostListing = lazy(() => import(/* webpackPrefetch: true */ "./pages/FacebookPostListing"));
const Wallethistory = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/Wallethistory"));
const Benificiary = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/Benificiary"));
const Withdraw = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/Withdraw"));
const Topup = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/Topup"));
const Wallet = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/Wallet"));
const Adbeneficiary = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Wallet/adbeneficiary"));
const Productlist = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Products/Productlist"));
const AddProduct = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Products/AddProduct"));
const ProductEdit = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Products/productedit"));
const ManageLeadProduct = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Products/manage_lead"));
const Buyleads = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Buyleads/Buyleads"));
const Catalog = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Catalog/Catalog"));
const AdCatalog = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Catalog/AdCatalog"));
const InvoicePrint = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Invoiceprint"));
const History = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/khatahistory"));
const Invoicedraft = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/invoicedraft"));
const Purchaseclient = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/buyerkhata/Purchaseclient"));
const Clientaddbuyer = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/buyerkhata/clientaddbuyer"));
const ClientAddform = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/clientaddform"));
const Newinvoice = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/newinvoice"));
const KhataDashboard = lazy(() => import(/* webpackPrefetch: true */ "./pages/KhataDashboard"));
const AnalyticsPage = lazy(() => import(/* webpackPrefetch: true */ "./pages/AnalyticsPage"));
const KhataLedgerInvoice = lazy(() => import(/* webpackPrefetch: true */ "./pages/KhataLedgerInvoice"));
const Khataclient = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Khataclient"));
const Adddeliverychallan = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/adddeliverychallan"));
const Invoiceaddclient = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Invoiceaddclient"));
const Deliveryaddclient = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Deliveryaddclient"));
const Khatadeliverychallan = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Khatadeliverychallan"));
const Khatamanageinvoice = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/Khatamanageinvoice"));
const ClientEditform = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/clienteditform"));
const Addbalance = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/add_balance"));
const Mainpage2 = lazy(() => import(/* webpackPrefetch: true */ "./pages/mainpage2"));
const Leadsrequest = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/Buyrequest/Buyleads"));
const Client = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/buyerkhata/Khataclient"));
const Viewchallan = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/buyerkhata/Khatadeliverychallan"));
const Invoice = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/buyer/buyerkhata/Khatamanageinvoice"));
const Director = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/director"));
const Adddirector = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/director_add"));
const Editdirector = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/editdirector"));
const CompanyImages = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/company_images"));
const Additional = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/additional"));
const Profile = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/profile/profile"));

// Shared Routes
const LeadView = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Buyleads/LeadView"));
const Packages = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Subscription/Packages"));
const Subscription = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Subscription/Subscription"));
const BuyPackageNow = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/Subscription/buypackage"));
const Page404 = lazy(() => import(/* webpackPrefetch: true */ "./pages/Page404"));
const ChatBox = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/chatbox/chatbox"));
const ChatboxInvoice = lazy(() => import(/* webpackPrefetch: true */ "./pages/leads/seller/khata/chatboxinvoice"));
const ErrorSystem = lazy(() => import(/* webpackPrefetch: true */ "./components/ErrorSystem"));

const WhatsappInquiryPage = lazy(() => import(/* webpackPrefetch: true */ "./components/landingpage/WhatsappInquiryPage"));


function App() {
  const location = useLocation();

  useEffect(() => {
    const canonicalLink = document.getElementById("canonical-link");
    if (canonicalLink) {
      canonicalLink.href = `${window.location.origin}${location.pathname}${location.search}`;
    }
  }, [location]);

  useEffect(() => {
    loadMetaPixel();
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location]);

  return (
    <>
    
    {/* <GTranslate /> */}
      <Meta />
      <ScrollToTop />
      <Suspense fallback={<LoaderProvider/>}>
        <Routes>

          {/* <Route path="/vendor" element={<Vendor />} /> */}
          {/* <Route path="/sub" element={<Sub />} />  */}
          {/* <Route path="/vendor-detail" element={<Vendor_Detail />} /> */}

          {/* Profile */}
          {/* <Route path="/" element={<Myrides />} /> */}
          {/* <Route path="/signup" element={<Signup />} /> */}
          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route path="/bulkproduct" element={<Bulkproduct />} /> */}
          {/* <Route path="/salereportdetail" element={<Salereportdetail />} /> */}
          {/* <Route path="/purchasereportdetail" element={<Purchasereportdetail />} /> */}
          {/* <Route path="/wareinvoices" element={<Wareinvoices />} /> */}

          {/* <Route path="/trade" element={<Trade />} /> */}
          {/* <Route path="/blogdetail" element={<Blogdetail />} /> */}
          {/* <Route path="/product" element={<Final />} /> */}

          {/* <Route path="/w" element={<Web />} /> */}
          {/* <Route path="/warehouse_management" element={<Warehouse />} /> */}
          {/* <Route path="/single" element={<Single />} /> */}
          {/* <Route path="/book" element={<Book />} /> */}
          {/* <Route path="/old" element={<Homepage />} /> */}

          {/* <Route path="/main" element={<Main />} /> */}
          {/* <Route path="/sub" element={<Subcat />} /> */}

          {/* <Route path="/x" element={<Upload />} /> */}

          {/* Warehouse */}
          {/* <Route path="/warehouse1" element={<Addwarehouse1 />} />
          <Route path="/warehousebook" element={<Warehousebooking />} />
          <Route path="/warehouselist" element={<Warehouselist />} /> */}
          {/* Matter Sheet  */}
          {/* <Route path="/mattersheetlist" element={<Mattersheetlist />} /> */}
          {/* <Route
            path="/mattersheetdirector"
            element={<Mattersheetdirector />}
          /> */}
          {/* <Route path="/table" element={<Table />} /> */}
          {/* Seller Logistics */}
          {/* <Route path="/request" element={<Request />} /> */}
          {/* <Route path="/bookingreceipt" element={<Bookingreceipt />} /> */}
          {/* <Route
            path="/bookingrequestrider"
            element={<Bookingrequest_byRider />}
          /> */}
          {/* <Route
            path="/bookingrequestuser"
            element={<Bookingrequest_byUser />}
          /> */}
          {/* <Route path="/rebid" element={<Bookingrequest_byUser_rebid />} /> */}

          {/* <Route path="/driver" element={<Driverreg />} /> */}
          {/* Ad-ons */}
          {/* <Route path="/advertisewithus" element={<Advertisewithus />} /> */}
          {/* <Route path="/orderlist" element={<Orderlist />} /> */}
          {/* <Route path="/webmarketing" element={<Webmarketing />} /> */}
          {/* <Route path="/purchaseorder" element={<Purchaseorder />} /> */}
          {/* <Route path="/adpurchaseorder" element={<AdPurchaseorder />} /> */}
          {/* <Route path="/requestedbooking" element={<Requestedbooking />} /> */}
          {/* <Route path="/bookinginvoices" element={<Bookinginvoices />} /> */}


          {/* Inventory */}
          {/* <Route path="/inventory" element={<Inventory />} /> */}
          {/* <Route path="/productdef" element={<Productdef />} />
          <Route path="/productpricing" element={<Productpricing />} />
          <Route path="/productslist" element={<Productslist />} />
          <Route path="/report" element={<Report />} />
          <Route path="/sales" element={<Salesreturn />} />
          <Route path="/stocklevels" element={<Stocklevels />} />
          <Route path="/producteditin" element={<ProductEditInventory />} /> */}

          {/* Ewallet */}
          {/* <Route path="/bwallethistory" element={<BWallethistory />} />
          <Route path="/bb" element={<BBenificiary />} />
          <Route path="/bwithdraw" element={<BWithdraw />} />
          <Route path="/bd" element={<BTopup />} />
          <Route path="/bwallet" element={<BWallet />} /> */}

          {/* profile */}
          {/* <Route path="/producte" element={<Myproducts />} /> */}
          {/* <Route path="/user" element={<User />} /> */}
          {/* <Route path="/interest" element={<Productinterest />} />
          <Route path="/newinterest" element={<Productinterestadd />} /> */}

          {/* <Route path="/newcertificate" element={<Certificate />} /> */}
          {/* <Route path="/certificate" element={<Certificate_view />} /> */}

          {/* Office Management */}
          {/* <Route path="/employeelist" element={<Employee />} />
          <Route path="/newemployee" element={<Employee_form />} />
          <Route path="/updateemployee" element={<Emp_update />} />
          <Route path="/payrolllist" element={<Payroll />} />
          <Route path="/newpayroll" element={<Payroll_form />} /> */}
          {/* <Route path="/officedashboard" element={<Officedashboard />} /> */}
          {/* <Route path="/expense" element={<Bill />} />
          <Route path="/adexpense" element={<Adbill />} /> */}
          {/* <Route path="/nav" element={<Nav />} /> */}
          
          {/* Website Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/main" element={<Mains />} />
          <Route path="/sub/:slug" element={<Sub2 />} />
          <Route path="/product/:id/:slug" element={<Product_Detail />} />
          <Route path="/product/:id" element={<Product_Detail />} />
          <Route path="/product" element={<Product_Detail />} />

          <Route path="/supplier" element={<Supplier />} />
          <Route path="/spinner" element={<Spinner />} />
          <Route path="/companydetail/:id/:slug" element={<Companypage />} />
          <Route path="/companydetail/:id" element={<Companypage />} />
          <Route path="/companydetail" element={<Companypage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgotten" element={<Forgotten />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/get-quote" element={<GetQuotePage />} />
          <Route path="/master-login" element={<MasterLogin />} />
          <Route path="/inquiry" element={<WhatsappInquiryPage />} />
          

          {/* Admin Panel Routes */}
          <Route path="/requestno" element={<Requestno />} />
          <Route path="/sendrequest" element={<Sendrequest />} />
          <Route path="/sendquote" element={<Sendquote />} />
          <Route path="/seller" element={<Mainpage />} />
          <Route path="/facebookIntegrationPage" element={<FacebookIntegrationPage />} />
          <Route path="/facebookListing" element={<FacebookListing />} />
          <Route path="/facebookPosting" element={<FacebookPosting />} />
          <Route path="/facebookPostListing" element={<FacebookPostListing />} />
          <Route path="/wallethistory" element={<Wallethistory />} />
          <Route path="/beni" element={<Benificiary />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/topup" element={<Topup />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/adbenificiary" element={<Adbeneficiary />} />
          <Route path="/productlist" element={<Productlist />} />
          <Route path="/addproduct" element={<AddProduct />} />
          <Route path="/productlead" element={<ManageLeadProduct />} />
          <Route path="/productedit" element={<ProductEdit />} />
          <Route path="/buyleads" element={<Buyleads />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/adcatalog" element={<AdCatalog />} />
          <Route path="/invoiceprint" element={<InvoicePrint />} />
          <Route path="/history" element={<History />} />
          <Route path="/invoicedraft" element={<Invoicedraft />} />
          <Route path="/purchaseclient" element={<Purchaseclient />} />
          <Route path="/clientaddbuyer" element={<Clientaddbuyer />} />
          <Route path="/clientAddform" element={<ClientAddform />} />
          <Route path="/newinvoice" element={<Newinvoice />} />
          <Route path="/khata-dashboard" element={<KhataDashboard />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/khata-ledger" element={<KhataLedgerInvoice />} />
          <Route path="/khataclient" element={<Khataclient />} />
          <Route path="/adddeliverychallan" element={<Adddeliverychallan />} />
          <Route path="/invoiceclient" element={<Invoiceaddclient />} />
          <Route path="/deliveryclient" element={<Deliveryaddclient />} />
          <Route path="/khatadeliverychallan" element={<Khatadeliverychallan />} />
          <Route path="/khatamanageinvoice" element={<Khatamanageinvoice />} />
          <Route path="/clienteditform" element={<ClientEditform />} />
          <Route path="/addbalance" element={<Addbalance />} />
          <Route path="/buyer" element={<Mainpage2 />} />
          <Route path="/product-buy-request" element={<Leadsrequest />} />
          <Route path="/buyerclient" element={<Client />} />
          <Route path="/buyerchallan" element={<Viewchallan />} />
          <Route path="/buyer_invoice" element={<Invoice />} />
          <Route path="/director" element={<Director />} />
          <Route path="/adddirector" element={<Adddirector />} />
          <Route path="/editdirector" element={<Editdirector />} />
          <Route path="/companyimages" element={<CompanyImages />} />
          <Route path="/additional" element={<Additional />} />
          <Route path="/profile" element={<Profile />} />

          {/* Shared Routes */}
          <Route path="/lead-view" element={<LeadView />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/buypackage" element={<BuyPackageNow />} />
          <Route path="/chat" element={<ChatBox />} />
          <Route path="/chatboxinvoice" element={<ChatboxInvoice />} />
          <Route path="/error-system" element={<ErrorSystem />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
